import type {
  KeyChannelBinding,
  SetKeyChannelBindingsRequest,
  SetKeyChannelBindingsResponse,
} from '@nadoutong/contracts';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { UseMutationResult, UseQueryResult } from '@tanstack/react-query';
import { useSession } from '../hooks/useSession.tsx';
import { listBindings, setBindings } from './keyChannelBindings.ts';

const BINDINGS_KEY = ['key-channel-bindings'] as const;

export function useKeyChannelBindingsList(
  upstreamId: string,
  bucketId: string,
): UseQueryResult<readonly KeyChannelBinding[]> {
  const { fetchImpl } = useSession();
  return useQuery({
    queryKey: [...BINDINGS_KEY, upstreamId, bucketId],
    queryFn: async () => {
      const res = await listBindings(upstreamId, bucketId, fetchImpl);
      return res.bindings;
    },
    enabled: bucketId.length > 0,
  });
}

export function useSetKeyChannelBindings(
  upstreamId: string,
  bucketId: string,
): UseMutationResult<
  SetKeyChannelBindingsResponse,
  Error,
  SetKeyChannelBindingsRequest
> {
  const { fetchImpl } = useSession();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: SetKeyChannelBindingsRequest) =>
      setBindings(upstreamId, bucketId, body, fetchImpl),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: [...BINDINGS_KEY, upstreamId, bucketId] });
    },
  });
}
